export const helper = (
  prismaFilter: object,
  options?: { multiTableSearch?: boolean; insensitive?: boolean }
) => {
  return options?.multiTableSearch ?
      {
        some: {
          value: { ...prismaFilter, ...(options?.insensitive ? { mode: "insensitive" } : undefined) }
        }
      }
    : { ...prismaFilter, ...(options?.insensitive ? { mode: "insensitive" } : undefined) };
};
